
export default {
    TaxReportData: [
        
            {
              "id": 1,
              "name": "Michael",
              "date": "01 Aug 2023",
              "invoice": "#312345",
              "amount": "$3000.00",
              "paymentMethod": "Cash",
              "itemsSold": 12,
              "averagePrice": "$375"
            },
            {
              "id": 2,
              "name": "Richard",
              "date": "12 Aug 2023",
              "invoice": "#236348",
              "amount": "$2000.00",
              "paymentMethod": "Cash",
              "itemsSold": 8,
              "averagePrice": "$247"
            },
            {
              "id": 3,
              "name": "Joseph",
              "date": "16 Sep 2023",
              "invoice": "#395374",
              "amount": "$17200.00",
              "paymentMethod": "Cash",
              "itemsSold": 10,
              "averagePrice": "$172"
            },
            {
              "id": 4,
              "name": "David",
              "date": "24 Sep 2023",
              "invoice": "#312345",
              "amount": "$32000.00",
              "paymentMethod": "Cash",
              "itemsSold": 14,
              "averagePrice": "$590"
            },
            {
              "id": 5,
              "name": "Benjamin",
              "date": "19 Oct 2022",
              "invoice": "#893246",
              "amount": "$24000.00",
              "paymentMethod": "Cash",
              "itemsSold": 12,
              "averagePrice": "$375"
            },
            {
              "id": 6,
              "name": "Steven",
              "date": "20 Oct 2022",
              "invoice": "#457289",
              "amount": "$12000.00",
              "paymentMethod": "Cash",
              "itemsSold": 5,
              "averagePrice": "$440"
            }
          ]
          
      
};
